import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistFR() {
  const articleData = {
    title: 'Votre ex est-il un narcissique caché ? (Les textes ne mentent pas)',
    description: 'Vous vous demandez si votre ex est un narcissique caché ? Découvrez 7 comportements manipulateurs subtils que notre IA détecte instantanément dans les SMS.',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Rédaction Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: "Qu'est-ce qu'un narcissique caché et comment diffère-t-il des narcissiques ouverts ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Les narcissiques cachés dissimulent leurs comportements manipulateurs derrière du charme, des tactiques émotionnelles subtiles et des messages passifs-agressifs, contrairement aux narcissiques évidents et ouverts.'
      }
    }, {
      '@type': 'Question',
      name: "L'IA peut-elle détecter le narcissisme caché dans les SMS ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Oui. Toxic Detector analyse le ton, la culpabilisation, les cycles de love-bombing, l'incohérence et les schémas de manipulation émotionnelle pour signaler le comportement narcissique caché."
      }
    }, {
      '@type': 'Question',
      name: 'Quels sont les comportements courants des narcissiques cachés dans les textes ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Manipulation émotionnelle, gaslighting, commentaires passifs-agressifs, jouer la victime, love-bombing suivi de retrait, et contrôle subtil.'
      }
    }, {
      '@type': 'Question',
      name: "Comment puis-je me protéger d'un narcissique caché ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Documentez les messages, faites confiance à votre instinct, maintenez des limites et utilisez des outils comme Toxic Detector pour identifier objectivement les schémas manipulateurs.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/fr/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Lien copié dans le presse-papiers !');
    }
  };
  return <>
      <MetaTags title="Votre ex est-il un narcissique caché ? Comment l'IA détecte la manipulation | ToxicDetector" description="Vous vous demandez si votre ex est un narcissique caché ? Découvrez 7 comportements manipulateurs subtils que notre IA détecte instantanément." keywords="signes narcissique caché, comportement narcissique dissimulé, manipulation narcissique textes, détecteur narcissique IA" canonical={`https://toxicdetector.com/fr/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-5622" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-5623">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-5624">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-5625">
            <div className="flex items-center justify-between" data-id="element-5626">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-5627">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Partager l'article" data-id="element-5628">
                <Share2 size={20} className="text-gray-600" data-id="element-5629" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-5630">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-5631">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-5632" />
            Retour au Blog
          </Link>

          <header className="mb-12" data-id="element-5633">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-5634">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-5635">
              <time dateTime={articleData.publishDate} data-id="element-5636">
                {new Date(articleData.publishDate).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-5637">•</span>
              <span data-id="element-5638">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-5639">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="Femme analysant des SMS montrant des signes de manipulation narcissique cachée avec l'IA" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-5640" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-5641">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-5642">
              Table des Matières
            </h2>
            <ul className="space-y-3 text-sm" data-id="element-5643">
              <li data-id="element-5644">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5645">
                  <span className="text-gray-400" data-id="element-5646">→</span> 1. Manipulation
                  émotionnelle dans chaque message
                </a>
              </li>
              <li data-id="element-5647">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5648">
                  <span className="text-gray-400" data-id="element-5649">→</span> 2. Gaslighting qui
                  s'accumule lentement
                </a>
              </li>
              <li data-id="element-5650">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5651">
                  <span className="text-gray-400" data-id="element-5652">→</span> 3. Commentaires
                  passifs-agressifs
                </a>
              </li>
              <li data-id="element-5653">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5654">
                  <span className="text-gray-400" data-id="element-5655">→</span> 4. Jouer la victime
                  constamment
                </a>
              </li>
              <li data-id="element-5656">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5657">
                  <span className="text-gray-400" data-id="element-5658">→</span> 5. Love-Bombing puis
                  retrait
                </a>
              </li>
              <li data-id="element-5659">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5660">
                  <span className="text-gray-400" data-id="element-5661">→</span> 6. Contrôle caché et
                  surveillance
                </a>
              </li>
              <li data-id="element-5662">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5663">
                  <span className="text-gray-400" data-id="element-5664">→</span> 7. Ton incohérent
                  entre les canaux
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-5665">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-5666">
              Avez-vous déjà eu l'impression que votre ex vous manipulait en
              coulisses, tout en paraissant charmant et attentionné ? Ce sont
              des <strong data-id="element-5667">signes classiques d'un narcissique caché</strong>.
              Contrairement aux narcissiques évidents, les cachés dissimulent
              leur manipulation derrière des tactiques émotionnelles subtiles.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-5668">
              Notre <strong data-id="element-5669">IA détecte la manipulation cachée</strong>{' '}
              instantanément en analysant leurs textes. Voici comment.
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-5670">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5671">
                1️⃣ Manipulation émotionnelle dans chaque message
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5672">
                Les narcissiques cachés tordent les émotions pour obtenir ce
                qu'ils veulent.
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5673">
                <p className="italic text-gray-700 text-lg" data-id="element-5674">
                  "Je ne peux pas croire que tu sois contrarié pour ça..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5675">
                L'IA détecte la culpabilisation subtile et la pression
                émotionnelle cachée dans les messages quotidiens.
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-5676">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5677">
                2️⃣ Gaslighting qui s'accumule lentement
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5678">
                <p className="italic text-gray-700 text-lg" data-id="element-5679">
                  "Tu te souviens mal de ça..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5680">
                Les narcissiques cachés vous font douter de votre propre
                mémoire. L'IA signale les cas répétés où la réalité est
                déformée.
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-5681">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5682">
                3️⃣ Commentaires passifs-agressifs
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5683">
                <p className="italic text-gray-700 text-lg" data-id="element-5684">
                  "Bien sûr, tout ce qui te rend heureux..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5685">
                L'agressivité passive est une marque de fabrique du narcissisme
                caché. L'IA reconnaît le sarcasme, les piques sournoises et
                l'hostilité masquée.
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-5686">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5687">
                4️⃣ Jouer la victime constamment
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5688">
                <p className="italic text-gray-700 text-lg" data-id="element-5689">
                  "Après tout ce que j'ai fait pour toi..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5690">
                Les narcissiques cachés retournent souvent la faute, se faisant
                passer pour la victime. L'IA détecte les phrases conçues pour
                vous culpabiliser.
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-5691">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5692">
                5️⃣ Love-Bombing puis retrait
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5693">
                <p className="italic text-gray-700 text-lg" data-id="element-5694">
                  "Tu es la seule personne que j'ai jamais aimée 😢" → ghosting
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5695">
                Ce cycle classique d'affection intense suivi de distance
                émotionnelle est un signal d'alarme. L'IA identifie ces schémas
                à travers plusieurs chats.
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-5696">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5697">
                6️⃣ Contrôle caché et surveillance
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5698">
                <p className="italic text-gray-700 text-lg" data-id="element-5699">
                  "Je vérifiais juste... encore"
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5700">
                Le contrôle subtil déguisé en attention est une tactique cachée.
                L'IA signale les comportements de vérification répétés sans
                agression ouverte.
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-5701">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5702">
                7️⃣ Ton incohérent entre les canaux
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5703">
                <p className="italic text-gray-700 text-lg" data-id="element-5704">
                  Chat de groupe : joueur / 1:1 : critique
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5705">
                Les narcissiques cachés masquent souvent leur comportement
                publiquement tout en manipulant en privé. L'IA compare les
                conversations pour mettre en évidence les divergences.
              </p>
            </section>

            <section className="mb-12" data-id="element-5706">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5707">
                🛡 Comment vous protéger
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-5708">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-5709">
                  <li className="flex items-start gap-3" data-id="element-5710">
                    <span className="text-purple-600 font-bold" data-id="element-5711">•</span>
                    <span data-id="element-5712">
                      Faites confiance à votre instinct. N'ignorez pas les
                      signaux d'alarme.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-5713">
                    <span className="text-purple-600 font-bold" data-id="element-5714">•</span>
                    <span data-id="element-5715">Gardez des captures d'écran pour la clarté.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-5716">
                    <span className="text-purple-600 font-bold" data-id="element-5717">•</span>
                    <span data-id="element-5718">
                      Partagez votre expérience avec des amis ou un thérapeute.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-5719">
                    <span className="text-purple-600 font-bold" data-id="element-5720">•</span>
                    <span data-id="element-5721">
                      Utilisez des outils comme Toxic Detector pour identifier
                      les schémas.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-5722">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5723">
                💀 Voyez-le de vos propres yeux
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5724">
                Le narcissisme caché peut être difficile à repérer, mais l'IA ne
                manque rien. Téléchargez vos chats et obtenez une analyse
                instantanée :
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-5725">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-5726">
                  "🚩 78% manipulation détectée. Tactiques cachées identifiées
                  !"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-5727">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5728">
                Questions Fréquentes
              </h2>
              <div className="space-y-4" data-id="element-5729">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-5730">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-5731">
                      <span data-id="element-5732">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-5733" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-5734">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-5735">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-5736">
              💀 Prêt à découvrir la vérité ?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-5737">
              Arrêtez de deviner. Téléchargez vos textes sur Toxic Detector et
              obtenez un score de toxicité instantané. Notre IA révèle la
              manipulation cachée que vous auriez pu manquer.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-5738">
              <p className="font-bold text-xl" data-id="element-5739">
                "🚩 78% manipulation détectée. Tactiques cachées identifiées !"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-5740">
              Scannez vos chats maintenant →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: '7 Signes de Gaslighting que Notre IA Détecte Instantanément',
          description: "Apprenez les principaux schémas de gaslighting que l'IA détecte dans vos conversations textuelles.",
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: 'Le Guide Ultime des Textes Passifs-Agressifs',
          description: 'Repérez le comportement passif-agressif et la manipulation cachée dans les SMS.',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-5741" />

          <div className="mt-12 text-center" data-id="element-5742">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-5743">
              <Share2 size={18} className="mr-2" data-id="element-5744" />
              Partager cet article
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-5745">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-5746">
            <p className="text-gray-500 text-sm" data-id="element-5747">
              © {new Date().getFullYear()} ToxicDetector. Tous droits réservés.
            </p>
          </div>
        </footer>
      </div>
    </>;
}